import { Link } from "react-router-dom";
import heroBanner from "@/assets/images/pages/12-hour-adi.png";
import ShellCard from "../../components/ShellCard";
import PriceCard from "../../components/PriceCard";

const TwelveHourADI = () => {
  return (
    <>
      <section className="hero-slider-section">
        <div
          className="hero-banner"
          style={{
            backgroundImage: `url(${heroBanner})`,
          }}
        >
          <div className="banner-text-container">
            <div className="banner-heading">
              <h1 className="banner-title">12 Hour A.D.I. Course</h1>
              <p className="banner-subheading">State of Florida Certified</p>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container my-5">
          <div className="row justify-content-center">
            <div className="col-12">
              <ShellCard>
                <h3 className="mb-4" style={{ color: "var(--metro-yellow)" }}>
                  Course Details
                </h3>
                <div className="text-light lh-lg">
                  <p className="mb-4">
                    The 12 hour Advanced Driver Improvement (ADI 12) course is
                    available in both the online format and in the classroom
                    format. The ADI Driving course also known as ADI training is
                    for drivers that require advanced driver improvement
                    training.
                  </p>

                  <p className="mb-4">
                    The ADI Driving course objective is to identify driving
                    behaviors that are leading to the troublesome driving
                    habits. By completing the ADI training course and actively
                    participating in ADI School discussions, drivers will be
                    better prepared to make informed choices to determine future
                    driving behavior.
                  </p>

                  <div
                    className="p-3 rounded mb-4"
                    style={{
                      backgroundColor: "#333333",
                      border: "1px solid var(--metro-yellow)",
                    }}
                  >
                    <p className="mb-0 fw-bold" style={{ color: "var(--metro-yellow)" }}>
                      Important: The ADI 12 class may only be taken in the event
                      of a:
                    </p>
                    <ul className="mt-2 mb-0 list-unstyled">
                      <li className="mb-2">
                        <i
                          className="fas fa-gavel me-2"
                          style={{ color: "var(--metro-yellow)" }}
                        ></i>
                        Court Order
                      </li>
                      <li className="mb-2">
                        <i
                          className="fas fa-exclamation-triangle me-2"
                          style={{ color: "var(--metro-yellow)" }}
                        ></i>
                        Point Suspension (i.e. 12 points in 12 months) or
                      </li>
                      <li>
                        <i
                          className="fas fa-ban me-2"
                          style={{ color: "var(--metro-yellow)" }}
                        ></i>
                        HTO (Habitual Traffic Offender)
                      </li>
                    </ul>
                  </div>

                  <p className="mb-4">
                    If the ADI 12 is being completed due to a judgment, the
                    student needs to provide the ADI School with the citation
                    information for which the judgment was imposed.
                  </p>

                  <p className="mb-4">
                    If the ADI 12 is being completed due to a point suspension
                    or HTO, the student must inform the ADI School at the time
                    of enrollment so we can ensure that the correct information
                    is reported to the DMV.
                  </p>

                  <div>
                    <p className="mb-2 fw-bold">
                      After completing registration:
                    </p>
                    <p className="mb-0">
                      We will issue the student a letter of enrollment allowing
                      the student to apply for a hardship License.{" "}
                      <span className="fw-bold">
                        You are guaranteed to pass – Free retakes.
                      </span>
                    </p>
                  </div>
                </div>
              </ShellCard>
            </div>
          </div>
        </div>
      </section>

      <section
        id="registration"
        style={{ backgroundColor: "#111111", color: "#ffffff" }}
      >
        <div className="container pb-5">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <Link
                to="https://12houradi.metrotrafficschool.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-lg px-4 py-3 fw-bold text-dark metro-btn-primary text-decoration-none"
                style={{
                  backgroundColor: "var(--metro-yellow)",
                  border: "none",
                }}
              >
                <i className="fas fa-user-graduate me-2"></i>
                RETURNING STUDENTS
              </Link>
            </div>
          </div>

          <div className="col-12 text-center mb-5">
            <div className="row g-3 justify-content-center">
              <PriceCard
                iconClass="fas fa-chalkboard-teacher fa-2x"
                title="Classroom ADI Course"
                price="$120.00"
                buttonText="Register Now - Classroom ADI"
                onClick={() => { }}
                buttonProps={{
                  'data-bs-toggle': 'modal',
                  'data-bs-target': '#adi-classroom-modal'
                }}
              />
              <PriceCard
                iconClass="fas fa-laptop fa-2x"
                title="Online ADI Course"
                price="$79.95"
                buttonText="Register Now - Online ADI"
                buttonLink="https://12houradi.metrotrafficschool.com/register/MTY="
                buttonProps={{
                  className:
                    "btn btn-lg px-4 py-3 fw-bold text-dark metro-btn-secondary",
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <div className="my-5 container contact-call">
        <p className="mt-3 fw-bold mb-0">
          Call{" "}
          <a href="tel:1-888-41-METRO" className="contact-phone">
            1-888-41-METRO
          </a>{" "}
          for more information.
        </p>
      </div>

      {/* ADI Classroom Modal */}
      <div
        className="modal fade"
        id="adi-classroom-modal"
        tabIndex="-1"
        aria-labelledby="adiClassroomLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content bg-dark text-white">
            <div className="modal-header bg-dark border-0">
              <h5 className="modal-title" id="adiClassroomLabel">
                Classroom ADI Course
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body bg-dark">
              <p className="mb-0">
                Please call{" "}
                <a
                  href="tel:305-553-5000"
                  className="fw-bold"
                  style={{ color: "var(--metro-yellow)" }}
                >
                  305-553-5000
                </a>{" "}
                to enroll for the classroom version of the ADI course offered
                only Miami-Dade, Broward and Palm Beach Counties.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TwelveHourADI;
